import React, {useEffect} from "react";
import Breadcrumbs from "../breadcrumbs";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { graphql, useStaticQuery } from 'gatsby';
import { getBrText } from "../../helpers/helper.rendering";

const Main = () => {

    const { realEstate } = useStaticQuery(graphql`
    query {
        realEstate {
            name
            about_us
            sections{
                about{
                    image
                }
            }
        }
    }`)
    
    useEffect(() => {
        AOS.init({ duration : 2000});
    }, [])

    return (
        <section className="about-main banner-main">
            <div className="container-fluid">
                <div className="row content-main d-flex align-items-center">
                    <div className="col-12">
                        <div className="row pt-lg-0 pt-5">
                            <div className="col-12">
                                <Breadcrumbs
                                    props={[
                                    { name: realEstate.name, route: "/", location: "" },
                                    { name: "Nosotros", route:   "", location: ""},
                                    ]}
                                />
                            </div>
                            <div className="col-lg-12 order-2 order-lg-1">
                                <h1 className="mb-lg-4">
                                    Somos {realEstate.name} <br />
                                </h1>
                                <h2>
                                    {getBrText(realEstate.about_us).map(element => (
                                        <>
                                            {element}
                                            <br className="d-none d-lg-block" />
                                        </>
                                    ))}
                                </h2>
                                {/* <a className="btn btn-blue goto_about">CONOCENOS</a> */}
                            </div>
                            {/* <div className="col-lg-4 text-lg-end col-xl-3 order-1 order-lg-2">
                                <p>sobre nosotros   <span className="no-ls"> ——— </span>   quiénes somos </p>
                            </div> */}
                            <div className="col-12 order-3">
                                <img className="w-100" src={realEstate.sections.about.image} alt={realEstate?.name} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
} 

export default Main;